module.exports = __webpack_public_path__ + "static/media/x-lg.aec9b21b.svg";